// Reports Core Web Vitals (CLS, INP, FCP, LCP, TTFB) to the logger and
// attaches them as Sentry tags so performance regressions show up in the
// Sentry dashboard. Called once from main.ts.

import { onCLS, onINP, onFCP, onLCP, onTTFB, type Metric } from 'web-vitals'
import { logger } from '@core/logging/logger'
import { flags } from '@core/config'
import { SentryService } from '../sentry'

const report = (metric: Metric): void => {
  logger.info(`web vital ${metric.name}`, {
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    id: metric.id,
  })

  SentryService.setTag(`web_vital.${metric.name.toLowerCase()}`, metric.rating)
}

export const initWebVitals = (): void => {
  if (!flags.webVitalsEnabled) return
  onCLS(report)
  onINP(report)
  onFCP(report)
  onLCP(report)
  onTTFB(report)
}
